module.exports = __webpack_public_path__ + "img/weight_one.06c4ee9d.png";